// FILECONTENT_START src/common/components/HtmlView/HtmlView.tsx
import { Box, BoxProps, useTheme } from "@mui/material";
import replaceVimeoEmbeds from "utils/replaceVimeoEmbeds";

export interface HtmlViewProps extends BoxProps {
  id?: string;
  value?: string;
}

export default function HtmlView({ id, value, sx, ...rest }: HtmlViewProps) {
  const theme = useTheme();
  const color = theme.palette.text.primary;

  if (!value || value === "") {
    return null;
  }

  function beautifyHtml(html: string) {
    return replaceVimeoEmbeds(html || "")
      .replace("<br><br><br><br><br><br>", "")
      .replace(/rgb\(0, 0, 0\)/g, color)
      .replace(/rgb\(0,0,0\)/g, color)
      .replace(/rgb\(255, 255, 255\)/g, color)
      .replace(/rgb\(255,255,255\)/g, color)
      .replace("<br><br><br><br><br><br>", "");
  }
  return (
    <Box
      sx={{ "&>p": { marginTop: 0, marginBottom: 0 }, ...sx }}
      dangerouslySetInnerHTML={{ __html: beautifyHtml(value) }}
      {...rest}
    />
  );
}

// FILECONTENT_END src/common/components/HtmlView/HtmlView.tsx
